/**
 * Biopet Professional — aliases to supplement recommendation helpers.
 */
import {
  BIOPET_ESSENTIAL_SUPPLEMENT_FORMULA as BIOPET_ESSENTIAL_SUPPLEMENT_FORMULA_BASE,
  BIOPET_ESSENTIAL_SUPPLEMENT_SLOT_BY_COUNT as BIOPET_ESSENTIAL_SUPPLEMENT_SLOT_BY_COUNT_BASE,
  resolveBiopetSupplementSlots as resolveBiopetSupplementSlotsBase,
  recommendBiopetEssentialSupplements as recommendBiopetEssentialSupplementsBase,
  getPetCareProRecommendedSupplementList as getPetCareProRecommendedSupplementListBase
} from '../biopet_essential/calculate_biopet_essential_supplement';

export const BIOPET_PROFESSIONAL_SUPPLEMENT_FORMULA = BIOPET_ESSENTIAL_SUPPLEMENT_FORMULA_BASE;
export const BIOPET_PROFESSIONAL_SUPPLEMENT_SLOT_BY_COUNT = BIOPET_ESSENTIAL_SUPPLEMENT_SLOT_BY_COUNT_BASE;
export const resolveBiopetProfessionalSupplementSlots = resolveBiopetSupplementSlotsBase;
export const recommendBiopetProfessionalSupplements = recommendBiopetEssentialSupplementsBase;
export const getPetCareProRecommendedSupplementList = getPetCareProRecommendedSupplementListBase;

// Backward-compatible aliases
export const BIOPET_ESSENTIAL_SUPPLEMENT_FORMULA = BIOPET_PROFESSIONAL_SUPPLEMENT_FORMULA;
export const resolveBiopetSupplementSlots = resolveBiopetProfessionalSupplementSlots;
export const recommendBiopetEssentialSupplements = recommendBiopetProfessionalSupplements;
